import * as analytics from 'analytics/Analytics';
import {MOLBIO_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import generateTimestampedName from 'notebook/mediocre/clipboard/generateTimestampedName';

/**
 * Determine whether an array of plain text strings corresponds to a molfile.
 *
 * The specification was taken from https://en.wikipedia.org/wiki/Chemical_table_file#Molfile:
 * - header block consisting of 3 lines: title, program, and comment
 * - 4th line is the counts line (V2000) or the V2000-compatibility line (V3000), which ends in the version
 *   number
 * - atom block
 * - bond block
 * - final line is always `M  END`
 */
export function isMolfile(lines: Array<string>): boolean {
  const endlineRegex = /^M {2}END$/;
  return lines.length > 4 && /(V2000)|(V3000)$/.test(lines[3]) && endlineRegex.test(lines[lines.length - 1]);
}

export function cleanText(text: string): Array<string> {
  // Only trim trailing whitespace as the leading whitespace may be part of the header block.
  return text.replace(/\s*$/, '').split(/\r?\n/);
}

export default function parseMolBioFile(clipboardData: DataTransfer): File | null {
  const text = clipboardData.getData('text/plain');
  const lines = cleanText(text);
  if (isMolfile(lines)) {
    analytics.deprecatedTrackEvent(MOLBIO_ANALYTICS_ACTIONS.UPLOADED_MOLFILE);
    const type = 'chemical/x-mdl-molfile';
    const blob = new Blob([text], {type});
    const fileName = `${lines[0].trim() !== '' ? lines[0] : generateTimestampedName()}.mol`;
    return new File([blob], fileName, {type});
  }
  return null;
}
